import { render } from "./principalDialog.vue?vue&type=template&id=faccde80&scoped=true"
import script from "./principalDialog.vue?vue&type=script&lang=js"
export * from "./principalDialog.vue?vue&type=script&lang=js"

import "./principalDialog.vue?vue&type=style&index=0&id=faccde80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faccde80"]])

export default __exports__